import { render, staticRenderFns } from "./updateGradeConversionForm.vue?vue&type=template&id=5c970965"
import script from "./updateGradeConversionForm.vue?vue&type=script&lang=js"
export * from "./updateGradeConversionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports